import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import styled from 'styled-components';
import HeaderLobby from '../organisms/HeaderLobby'
import { MINIAPP, MICROAPP, OPEN_NEW_MICROAPP } from '../../constants';
import * as sdkclaro from '@claropay/claro-pay-sdk-v2'
import { executeTaggeo } from '../../store/actions';
import { getCanMultiAnalytics, getOriginParamsSelector, getParamsFromUrl } from '../../store/selectors/paymentsSelectors';
import { getServicesTelcel } from '../organisms/utils';

const Container = styled.div`
  width: 100%;
  overflow: scroll;
  background: #fff;
`;

const ContBoxNotMember = styled.div`
  font-size: 14px;
  font-weight: bold;
  align-items: center;
  width: 90%;
  height: auto;
  border-radius: 8px;
  margin: 0 auto 26px auto;
  box-shadow: 0px 0px 23px 0px rgba(1, 32, 36, 0.15);
  padding-bottom: 4%;
  padding-top: 3%;
`;

const ImgPaquetes = styled.img`
  width: ${props => props.isContainerTelcel && !props.isClaroPartner ? '45px' : '30px'};
  height: ${props => props.isContainerTelcel && !props.isClaroPartner ? '45px' : '30px'};
  margin: ${props => props.isContainerTelcel && !props.isClaroPartner ? '8px 5px 3px 12px' : '0% 0% -1% 2%'};
`;

const ItemTitle = styled.span`
    margin-left: 13px;
    vertical-align: super;
    color: ${props => props.isContainerTelcel && !props.isClaroPartner ? "#222222" : "#50626C"};
    ${props => props.isContainerTelcel && !props.isClaroPartner ? 'position: relative' : ''};
    ${props => props.isContainerTelcel && !props.isClaroPartner ? 'top: -15px' : ''};
    ${props => props.isContainerTelcel && !props.isClaroPartner ? 'font-family: AMX-Bold' : ''};
    ${props => props.isContainerTelcel && !props.isClaroPartner ? 'font-size: 15px' : ''};
`;

class SearsContainer extends Component {
    
    constructor(props) {
        super(props)
        this.state = {
            serviceDataInfo: this.props.paymentsConfig           
        }
    }

    componentDidMount() { 
        if(this.props.canMultiAnalytics && this.props.isContainerTelcel) {
            this.props.executeTaggeo({
                eventName: "pay_service_or_tae",
                seccion: "servicios",
                subseccion: getServicesTelcel(-1),
                origen: this.props.originAnalytic,
                pantalla: "home amigo paguitos",
                trackState: true,
            }, true);
        } else {
            this.props.executeTaggeo({
                action: "View",
                step: "Amigo Paguitos",
                service : this.props.tagServiceId
            })
        }

        if (this.props.paramsFromUrl && this.props.paramsFromUrl.skipLobby) {
            document.getElementById('service_247').click();
        }
    }

    handleItem = (type, url, index, taggeoAction) => {
        const {
            history, 
            sdkVersion, 
            isClaroPartner,
            paymentsConfig,
            trackId,
            tagServiceId
        } = this.props
        if(this.props.canMultiAnalytics && this.props.isContainerTelcel) {
            this.props.executeTaggeo({
                eventName: "pay_service_or_tae",
                seccion: "servicios",
                subseccion: getServicesTelcel(-1),
                origen: this.props.originAnalytic,
                pantalla: "home amigo paguitos",
                tipoElemento: "boton",
                nombreElemento: index === 0? "paga un amigo paguitos" : "consulta un amigo paguitos",
                trackAction: true,
            }, true);
        } else {
            this.props.executeTaggeo({
                action: taggeoAction,
                step: "Amigo Paguitos",
                service : this.props.tagServiceId
            })
        }
        if(type === MINIAPP ){
            window.location.href = "https://telcel.solucionfaas.com";
            /*history.push({ 
                pathname: `/external-site`,
                state: {
                    url
                }
            })*/
        }

        if(type === MICROAPP) {
            history.push({ 
                pathname: `/payment-service`,
                state: {
                    serviceConfigIndex:index,
                    sdkVersion,
                    isClaroPartner,
                    paymentsConfig,
                    trackId,
                    tagServiceId
                }
            })
        }
        if(type === OPEN_NEW_MICROAPP ){
            console.log("ENTRO OPEN NAT");
            const url = {
                app: "startEventNoClose",
                to : "openMicroApp",
                parameters: JSON.stringify({microAppId: "amigoPaguitosAdminPs"}),
            };
            setTimeout(() => {
                sdkclaro.getInstance().openNative(
                    JSON.stringify(url),
                    () => {},
                    () => {},
                );
            }, 1000);
        }
    }

    render() {
        const { serviceDataInfo: {general, services} } = this.state;
        const { isContainerTelcel, isClaroPartner } = this.props;
        return (
            <Container>
                <HeaderLobby 
                    generalInfo = {general} 
                    isContainerTelcel={isContainerTelcel}
                    isClaroPartner={isClaroPartner} />
                {
                    services.map((service, index) => {
                        const {itemIcon, itemIconContainer, itemTitle, type, url, taggeoActionItem, serviceId } = service.serviceData.info
                        return <ContBoxNotMember
                            onClick={() => this.handleItem(type, url, index, taggeoActionItem)}
                            id={`service_${serviceId}`}
                        >
                            <ImgPaquetes 
                                src={ isContainerTelcel && !isClaroPartner ? itemIconContainer : itemIcon } 
                                isContainerTelcel={isContainerTelcel}
                                isClaroPartner={isClaroPartner} />
                            <ItemTitle 
                                isContainerTelcel={isContainerTelcel}
                                isClaroPartner={isClaroPartner}>
                                { itemTitle }
                            </ItemTitle>
                        </ContBoxNotMember>
                    })
                }
            </Container>
        )
    }
}

function mapStateToProps(state) {
    const paramsFromUrl = getParamsFromUrl(state);
    const data = getOriginParamsSelector(state)
    const originAnalyticArray = data? data.split(",") : [];
    const origen = originAnalyticArray.length > 0? atob(originAnalyticArray[1]).toLowerCase() : "payment_services";
  return {
    paramsFromUrl,
    originAnalytic: origen,
    canMultiAnalytics: getCanMultiAnalytics(state),
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
        executeTaggeo
    },
    dispatch,
  );
}

SearsContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(SearsContainer);

export default SearsContainer